module.exports = __webpack_public_path__ + "static/media/PSE bnw.65614f07.jpg";